// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2059":"d0a784ff3ed57a7f","2888":"09abb8f00cdaca4c","4358":"d0a784ff3ed57a7f","6357":"d0a784ff3ed57a7f"}[chunkId] + ".css";
};